// TSS vite/03 §"Query keys". One namespace; the view + resolved filters are the
// cache discriminators.

export const kpiKeys = {
    all: ['kpis'],
    view: (view, params) => ['kpis', view, params],
};
